import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/content/Login'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/admin/Admin'),
    meta: {
      requireAuth: true,
      title: '虚拟仿真平台'
    },
    children: [
      {
        path: '/student',
        name: 'Studentmanagement',
        component: () => import('../views/admin/Studentmanagement'),
        meta: {
          requireAuth: false,
        }
      },
      {
        path: '/class',
        name: 'Classmanagement',
        component: () => import('../views/admin/Classmanagement'),
        meta: {
          requireAuth: false
        }
      },
      {
        path: '/online',
        name: 'Useronline',
        component: () => import('../views/admin/Useronline'),
        meta: {
          requireAuth: false
        }
      },
      {
        path: '/loginlog',
        name: 'Loginlog',
        component: () => import('../views/admin/Loginlog'),
        meta: {
          requireAuth: false
        }
      },
      {
        path: '/question',
        name: 'Questionbank',
        component: () => import('../views/admin/Questionbank'),
        meta: {
          title: '理论题库',
          requireAuth: false
        }
      },
      {
        path: '/testpaper',
        name: 'Testpaper',
        component: () => import('../views/admin/Testpaper'),
        meta: {
          title: '理论试卷',
          requireAuth: false
        }
      },
      {
        path: '/exam',
        name: 'Exammanagement',
        component: () => import('../views/admin/Exammanagement'),
        meta: {
          title: '理论考试',
          requireAuth: false
        }
      },
      {
        path: '/score',
        name: 'Scoremanagement',
        component: () => import('../views/admin/Scoremanagement'),
        meta: {
          title: '理论考试',
          requireAuth: false
        }
      },
    ]
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index'),
    meta: {
      title: '虚拟仿真教学系统'
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('../views/content/Home'),
        meta: {
          title: '虚拟仿真教学系统'
        },
      },
      {
        path: '/introduction',
        name: 'Introduction',
        component: () => import('../views/content/Introduction'),
        meta: {
          title: '虚拟仿真教学系统'
        },
      },
      {
        path: '/team',
        name: 'Team',
        component: () => import('../views/content/Team'),
        meta: {
          title: '虚拟仿真教学系统'
        },
      },
      {
        path: '/resource',
        name: 'Resource',
        component: () => import('../views/content/Resource'),
        meta: {
          title: '虚拟仿真教学系统'
        },
      },
      {
        path: '/hardware',
        name: 'Hardware',
        component: () => import('../views/content/Hardware.vue'),
        meta: {
          title: '虚拟仿真教学系统'
        },
      },
      {
        path: '/testrecord',
        name: 'Testrecord',
        component: () => import('../views/content/Testrecord'),
        meta: {
          title: '虚拟仿真教学系统'
        },
      },
      {
        path: '/theorytest',
        name: 'Theorytest',
        component: () => import('../views/content/Theorytest'),
        meta: {
          title: '虚拟仿真教学系统'
        },
      },
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// const originalPush = VueRouter.prototype.push
//
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//
//   return originalPush.call(this, location).catch(err => err);
//
// }

export default router
